import {Injectable, OnInit} from '@angular/core';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import Swal from 'sweetalert2';
import { DemandeAccesComponent } from '../../dialogs/demande-acces/demande-acces.component';

@Injectable({
  providedIn: 'root'
})
export class AlertesService implements OnInit{

  constructor(private modalService: BsModalService) { }

  ngOnInit(): void {
  }

  Alert(message: 'Warning') {
    Swal.fire(message);
  }
  successNotification(title='Good',body='Merci !') {
    Swal.fire(title, body, 'success');
  }
  errorNotification(title='Erreur',body='Merci !') {
    Swal.fire(title, body, 'error');
  }
  warningNotification(title='Erreur',body='Merci !') {
    Swal.fire(title, body, 'warning');
  }
 

  ConfirmationDialog(title = 'Confirmation', body = 'Merci !'): Promise<boolean> {
    return Swal.fire({
      title: title,
      text: body,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('Envoyé!', 'Merci de confirmer l\'opération.', 'success');
        return true;
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Annulé', 'Opération annulée.', 'error');
        return false;
      }
    });
  }
  

  alertDemandeAccé(num_dossier) {
    Swal.fire({
      title: 'Demande accés',
      text: 'Vous n\'avez pas l\'accés requise !',
      icon: 'warning',
      // showCancelButton: true,
      confirmButtonText: 'Demander accés',
      // cancelButtonText: 'annuler',
    }).then((result) => {
      if (result.value) {
        const config: ModalOptions = {
          initialState: {
            data: num_dossier,
          
          }
        }
    
    
        // Ouvrir le modal
        const modalRef = this.modalService.show(DemandeAccesComponent, Object.assign({}, config, { class: 'modal-sm bg-secondary '}));
        // Swal.fire('Envoye!', 'Merci de confirmer l\'operations.', 'success');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        //Swal.fire('Cancelled', 'Product still in our database.)', 'error');
      }
    });
  }

  alertPaiementConfirmation(body:any) {
    Swal.fire({
      title: 'Paiement',
      text: 'Vous etes sur le point d\'effectuer un paiement de '+body.amount+' avec le '+body.phone_number,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, envoyer',
      cancelButtonText: 'No, annuler',
    }).then((result) => {
      if (result.value) {
        Swal.fire('Envoye!', 'Merci de confirmer l\'operations.', 'success');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        //Swal.fire('Cancelled', 'Product still in our database.)', 'error');
      }
    });
  }

  alertConfirmation() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'This process is irreversible.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, go ahead.',
      cancelButtonText: 'No, let me think',
    }).then((result) => {
      if (result.value) {
        Swal.fire('Removed!', 'Product removed successfully.', 'success');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Product still in our database.)', 'error');
      }
    });
  }


}
